// extracted by mini-css-extract-plugin
export default {"item":"Item_item__rSCHY","preview":"Item_preview__jxDRg","category":"Item_category__GJ6XS","title":"Item_title__Z8n7G","counter":"Item_counter__+y9q5"};